import clsx from "clsx";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../redux/slice";
import GroupLabel from "../../../Home/components/ColumnComponents/GroupLabel";
import { useGroupMeta } from "../../../Home/components/ColumnComponents/useGroupMeta";
import RowGroupActions from "../../../Home/components/RowGroupActions";
import TicketLimit from "../../../Home/components/TicketLimit";
import { ticketGroupsActions } from "../../../Tickets/redux/slice";
import GroupHeaderBarActions from "./GroupHeaderBarActions";
import { GroupsHeaderProps } from "./types";
import { useBoardsActions } from "../../../../components/useBoardsActions";
import { selectUserFormData } from "app/redux/selector";
import { IGroupHeaderMeta } from "../../types";

const GroupHeaderBar: React.FC<GroupsHeaderProps> = ({
  boardData,
  selectedTickets,
  group,
  minTableWidth,
  setIsGroupModalOpen,
  setIsRemoveGroup,
}) => {
  const dispatch = useDispatch();
  const { selectedProjectId } = useSelector(selectUserFormData);
  const { updateBoardsGroupsJson } = useBoardsActions(selectedProjectId);

  const groupTicketIds = group?.ticketsList?.map((t) => t._id) ?? [];
  const selectedCount = selectedTickets?.id?.filter((id) =>
    group?.ticketsList?.some((ticket) => ticket._id === id),
  )?.length;

  const allSelected =
    selectedCount > 0 && selectedCount === groupTicketIds.length;
  const handleSelectAll = () => {
    dispatch(actions.toggleSelectTicketByGroup(group));
  };
  const handleCollapsed = () => {
    dispatch(
      ticketGroupsActions.updateGroupActions({
        ...group,
        isCollapse: !group.isCollapse,
      }),
    );

    updateBoardsGroupsJson(boardData._id, () => {});
  };
  const meta = useGroupMeta(group._id);
  return (
    <div
      className={clsx(
        "w-full h-[30px] flex flex-row items-center gap-2 group ",
        allSelected ? "bg-[#E7F1FF]" : "bg-gray-400 hover:bg-gray-200 ",
      )}
      style={{ minWidth: minTableWidth }}
    >
      <div className="flex flex-row items-center sticky left-[62px] z-50 h-full gap-2">
        {/* group indicator dot */}
        <GroupHeaderBarActions
          group={group}
          isSelected={allSelected}
          handleSelectAll={handleSelectAll}
          handleCollapsed={handleCollapsed}
        />
        <GroupLabel
          group={group}
          groupBy={boardData?.groupBy}
          meta={meta as IGroupHeaderMeta  }
          tagsVisibleCount={10}
        />

        <TicketLimit
          group={group}
          count={group?.tickets?.length}
          maxCount={group?.ticketLimit}
        />
        <RowGroupActions
          group={group}
          setIsGroupModalOpen={setIsGroupModalOpen}
          setIsRemoveGroup={setIsRemoveGroup}
          groupBy={boardData.groupBy}
        />
      </div>
    </div>
  );
};

export default GroupHeaderBar;
